<template>
  <div class="h-100 d-flex flex-column bg-light">
    <div class="p-2 border-bottom bg-card d-flex align-items-center justify-content-between shadow-sm flex-wrap" style="z-index: 10;">
      <div class="d-flex align-items-center flex-wrap">
        <span class="font-weight-bold mr-2 text-main" style="font-size: 1.1rem; white-space: nowrap;">
          异动提醒
          <span v-if="prevDate" @click="switchToPrev" class="badge badge-warning ml-2" style="font-size: 0.85rem; vertical-align: middle; cursor: pointer;" title="点击返回上一交易日">
            <b-icon icon="arrow-left"></b-icon> {{ nextTradingDay }} {{ getWeekDay(nextTradingDay) }}
          </span>
          <span v-if="canSwitchToNext" @click="switchToNext" class="badge badge-warning ml-2" style="font-size: 0.85rem; vertical-align: middle; cursor: pointer;" title="点击切换到下一交易日">
            {{ date2 }} {{ getWeekDay(date2) }} <b-icon icon="arrow-right"></b-icon>
          </span>
        </span>
        <span class="text-muted mr-2 small">异动1:连续10个交易日内涨幅偏离值累计达到100% | 异动2:连续30个交易日内涨幅偏离值累计达到200% 红色:已达异动 黄色:即将到达 | 
          <span class="badge badge-danger cursor-help" style="font-size: 10px; padding: 2px 4px;" v-b-tooltip.hover.top="disclaimerText">异</span>:沪深交易所信息披露。</span>
      </div>

      <div class="d-flex align-items-center">
        <b-form-radio-group
          v-model="filterType"
          :options="filterOptions"
          buttons
          button-variant="outline-primary"
          size="sm"
          class="mr-2"
        ></b-form-radio-group>
        <WxShare title="异动提醒 - 自在量化" desc="连续10个/30个交易日内涨幅偏离值累计达到100%/200%的股票异动监控" class="mr-2" />
        <b-button variant="outline-primary" size="sm" @click="fetchList" class="border-0 mr-1">
          <b-icon icon="arrow-clockwise"></b-icon>
        </b-button>
        <b-button variant="outline-primary" size="sm" @click="downloadScreenshot" class="border-0">
          <b-icon icon="download"></b-icon>
        </b-button>
      </div>
    </div>
    <div class="flex-grow-1 bg-main overflow-auto" ref="tableContainer">
      <div v-if="loading" class="text-center p-5">
        <b-spinner small variant="primary"></b-spinner>
      </div>
      <div v-else-if="items.length===0" class="text-center p-5 text-muted">暂无数据</div>
      <div v-else>
        <!-- Desktop View -->
        <div v-if="!isMobile" class="px-3 pt-2">
         <div style="max-width: 1150px;" class="mx-auto w-100">
           <b-table
             :items="mergedItems"
             :fields="fields"
             striped
             hover
             small
             head-variant="light"
             class="mb-0 border shadow-sm rounded sticky-header-table"
             style="font-size: 12px;"
           >
            <template #cell(symbol)="data">
              <div class="font-weight-bold" style="white-space: nowrap; cursor: pointer;" @click="openSidebar(data.item)">
                <div :class="data.item.is_monitored ? 'text-danger' : 'text-main'">
                  {{ data.item.symbol_name || '' }}
                  <span v-if="data.item.is_monitored" class="badge badge-danger ml-1 cursor-help" style="font-size: 10px; padding: 2px 4px; vertical-align: text-top;" v-b-tooltip.hover.top="disclaimerText">异</span>
                </div>
                <div class="small text-secondary font-weight-normal">{{ data.item.symbol_code }}</div>
                <div v-if="data.item.is_monitored" class="small text-danger mt-1" style="font-size: 12px;">
                   {{ data.item.monitor_start_date }}~{{ data.item.monitor_end_date }}
                </div>
              </div>
            </template>

            <template #cell(gain)="data">
              <div class="mb-1"><span class="text-secondary small mr-1">10日</span>{{ formatPct(data.item.gain100) }}</div>
              <div><span class="text-secondary small mr-1">30日</span>{{ formatPct(data.item.gain200) }}</div>
            </template>

            <template #cell(days)="data">
              <div class="mb-1">{{ data.item.days1 }}</div>
              <div>{{ data.item.days2 }}</div>
            </template>

            <template #cell(trigger_today)="data">
              <div :class="getTodayStyle(data.item.gain_to_100, data.item.px_change_rate)" class="mb-1 rounded px-1">
                 <span class="font-weight-bold">{{ formatPct(data.item.gain_to_100) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_100) }}</span>
              </div>
              <div :class="getTodayStyle(data.item.gain_to_200, data.item.px_change_rate)" class="rounded px-1">
                 <span class="font-weight-bold">{{ formatPct(data.item.gain_to_200) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_200) }}</span>
              </div>
            </template>

            <template #cell(trigger_tomorrow)="data">
              <div :class="getFutureStyle(data.item.gain_to_100_2)" class="mb-1 rounded px-1">
                 <span class="font-weight-bold">{{ formatPct(data.item.gain_to_100_2) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_100_2) }}</span>
              </div>
              <div :class="getFutureStyle(data.item.gain_to_200_2)" class="rounded px-1">
                 <span class="font-weight-bold">{{ formatPct(data.item.gain_to_200_2) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_200_2) }}</span>
              </div>
            </template>

            <template #cell(trigger_day_after)="data">
              <div :class="getFutureStyle(data.item.gain_to_100_3)" class="mb-1 rounded px-1">
                 <span class="font-weight-bold">{{ formatPct(data.item.gain_to_100_3) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_100_3) }}</span>
              </div>
              <div :class="getFutureStyle(data.item.gain_to_200_3)" class="rounded px-1">
                 <span class="font-weight-bold">{{ formatPct(data.item.gain_to_200_3) }}</span> / <span class="font-weight-normal">{{ formatPrice(data.item.price_to_200_3) }}</span>
              </div>
            </template>

            <template #cell(px_change_rate)="data">
              <div class="font-weight-bold" :class="getColorClass(data.item.px_change_rate)">
                {{ formatPct(data.item.px_change_rate) }}
              </div>
              <div :class="getColorClass(data.item.px_change_rate)">
                {{ formatPrice(data.item.last_px) }}
              </div>
            </template>
           </b-table>
          </div>
        </div>

        <!-- Mobile View -->
        <div v-else class="p-1 bg-main" style="min-height: 100%;">
          <div v-for="(item, idx) in mergedItems" :key="idx" class="card border shadow-sm mb-1">
             <div class="card-body p-2">
                <div class="d-flex justify-content-between align-items-center mb-1 pb-1 border-bottom">
                   <div @click="openSidebar(item)">
                      <span class="font-weight-bold mr-2" :class="item.is_monitored ? 'text-danger' : 'text-main'" style="font-size: 1rem;">
                        {{ item.symbol_name }}
                        <span v-if="item.is_monitored" class="badge badge-danger ml-1" style="font-size: 10px; padding: 2px 4px; vertical-align: text-top;" v-b-tooltip.hover.top="disclaimerText">异</span>
                      </span>
                      <span class="text-secondary small">{{ item.symbol_code }}</span>
                      <div v-if="item.is_monitored" class="small text-danger mt-1">
                         {{ item.monitor_start_date }}~{{ item.monitor_end_date }}
                      </div>
                   </div>
                   <div class="text-right">
                      <span class="font-weight-bold mr-2" :class="getColorClass(item.px_change_rate)">{{ formatPrice(item.last_px) }}</span>
                      <span class="small" :class="getColorClass(item.px_change_rate)">{{ formatPct(item.px_change_rate) }}</span>
                    </div>
                </div>

                <!--异动1-->
                <div v-if="item.days1" class="bg-muted p-1 rounded mb-1">
                   <div class="d-flex justify-content-between align-items-center small mb-1 px-1">
                      <div>
                        <span class="badge badge-primary scale-8 mr-1">异动1</span>
                        <span class="text-secondary">{{ item.days1 }}天</span>
                      </div>
                      <div style="font-size: 0.85rem;">
                        <span class="text-muted mr-1">累计</span>{{ formatPct(item.gain100) }}
                      </div>
                   </div>
                   <div class="d-flex justify-content-between align-items-center bg-card p-1 rounded" style="font-size: 0.85rem;">
                      <div class="text-center" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">今日</div>
                        <div :class="getMobileThresholdClass(item.gain_to_100, item.px_change_rate)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_100) }}</span>
                        </div>
                      </div>
                      <div class="text-center border-left" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">明日</div>
                        <div :class="getMobileFutureClass(item.gain_to_100_2)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_100_2) }}</span>
                        </div>
                      </div>
                      <div class="text-center border-left" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">后日</div>
                        <div :class="getMobileFutureClass(item.gain_to_100_3)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_100_3) }}</span>
                        </div>
                      </div>
                   </div>
                </div>

                <!--异动2-->
                <div v-if="item.days2" class="bg-muted p-1 rounded">
                   <div class="d-flex justify-content-between align-items-center small mb-1 px-1">
                      <div>
                        <span class="badge badge-warning scale-8 mr-1">异动2</span>
                        <span class="text-secondary">{{ item.days2 }}天</span>
                      </div>
                      <div style="font-size: 0.85rem;">
                        <span class="text-muted mr-1">累计</span>{{ formatPct(item.gain200) }}
                      </div>
                   </div>
                   <div class="d-flex justify-content-between align-items-center bg-card p-1 rounded" style="font-size: 0.85rem;">
                      <div class="text-center" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">今日</div>
                        <div :class="getMobileThresholdClass(item.gain_to_200, item.px_change_rate)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_200) }}</span>
                        </div>
                      </div>
                      <div class="text-center border-left" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">明日</div>
                        <div :class="getMobileFutureClass(item.gain_to_200_2)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_200_2) }}</span>
                        </div>
                      </div>
                      <div class="text-center border-left" style="flex: 1;">
                        <div class="text-muted" style="font-size: 0.75rem;">后日</div>
                        <div :class="getMobileFutureClass(item.gain_to_200_3)">
                          <span class="font-weight-bold">{{ formatPct(item.gain_to_200_3) }}</span>
                        </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
        </div>
      </div>
    </div>
    <StockInfoSidebar :symbol_code="sidebarSymbolCode" :symbol_name="sidebarSymbolName" :date_mark="date1"></StockInfoSidebar>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
import WxShare from '@/components/share/WxShare.vue'
import moment from 'moment'

export default {
  components: {
    StockInfoSidebar: () => import('components/stock/StockInfoSidebar.vue'),
    WxShare
  },
  data(){
    return {
      sidebarSymbolCode: '',
      sidebarSymbolName: '',
      disclaimerText: '免责声明:带标记"异"的股票来自沪深交易所的交易信息披露。根据交易所规则“股票交易出现严重异动波动情形后10个交易日内，连续竞价阶段1分钟内单向申报买入（卖出）单只严重异常波动股票金额巨大的，交易所对有关交易行为予以重点监控。"',
      isGeneratingScreenshot: false,
      date1: new Date().toISOString().slice(0, 10),
      date2: '',
      prevDate: '',
      nextTradingDay: '',
      loading: false,
      filterType: 'all',
      filterOptions: [
        { text: '全部', value: 'all' },
        { text: '只要异动', value: 'monitored' },
        { text: '排除异动', value: 'not_monitored' }
      ],
      items: [],
      windowWidth: window.innerWidth,
      fields: [
        { key: 'symbol', label: '股票', sortable: false, thStyle: { width: '10%' } },
        { key: 'gain', label: '累计涨幅', sortable: false, class: 'text-right', thClass: 'text-right', thStyle: { width: '8%' } },
        { key: 'days', label: '天数', sortable: false, class: 'text-right', thClass: 'text-right', thStyle: { width: '5%' } },
        { 
          key: 'trigger_today', 
          label: '今日触发', 
          sortable: false, 
          class: 'text-right', 
          thClass: 'text-right', 
          thStyle: { width: '16%' }
        },
        { 
          key: 'trigger_tomorrow', 
          label: '明日触发', 
          sortable: false, 
          class: 'text-right', 
          thClass: 'text-right', 
          thStyle: { width: '16%' }
        },
        { 
          key: 'trigger_day_after', 
          label: '后日触发', 
          sortable: false, 
          class: 'text-right', 
          thClass: 'text-right', 
          thStyle: { width: '16%' }
        },
        { key: 'px_change_rate', label: '实时(幅/价)', sortable: true, class: 'text-right', thClass: 'text-right', thStyle: { width: '10%' } }
      ]
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768
    },
    canSwitchToNext() {
      if (!this.date2) return false
      const now = moment()
      const currentDate = now.format('YYYY-MM-DD')
      const currentTime = now.format('HH:mm')
      
      if (currentDate > this.date1) return true
      if (currentDate === this.date1 && currentTime >= '15:00') return true
      
      return false
    },
    mergedItems() {
      let items = this.items
      if (this.filterType === 'monitored') {
        items = items.filter(item => item.is_monitored)
      } else if (this.filterType === 'not_monitored') {
        items = items.filter(item => !item.is_monitored)
      }

      return items.map(item => {
        // Check validity based on threshold price (0 means no data)
        const hasT1 = item.t1_threshold_price > 0;
        const hasT2 = item.t2_threshold_price > 0;
        
        return {
          ...item,
          // Map backend t1_ fields to frontend fields, return null if invalid
          gain100: hasT1 ? item.t1_gain_pct : null,
          days1: hasT1 ? item.t1_days : null,
          dist100: hasT1 ? item.t1_space_pct : null,
          gain_to_100: hasT1 ? item.t1_threshold_gain_pct : null,
          price_to_100: hasT1 ? item.t1_threshold_price : null,
          gain_to_100_2: hasT1 ? item.t1_threshold_gain_pct2 : null,
          price_to_100_2: hasT1 ? item.t1_threshold_price2 : null,
          gain_to_100_3: hasT1 ? item.t1_threshold_gain_pct3 : null,
          price_to_100_3: hasT1 ? item.t1_threshold_price3 : null,
          
          gain200: hasT2 ? item.t2_gain_pct : null,
          days2: hasT2 ? item.t2_days : null,
          dist200: hasT2 ? item.t2_space_pct : null,
          gain_to_200: hasT2 ? item.t2_threshold_gain_pct : null,
          price_to_200: hasT2 ? item.t2_threshold_price : null,
          gain_to_200_2: hasT2 ? item.t2_threshold_gain_pct2 : null,
          price_to_200_2: hasT2 ? item.t2_threshold_price2 : null,
          gain_to_200_3: hasT2 ? item.t2_threshold_gain_pct3 : null,
          price_to_200_3: hasT2 ? item.t2_threshold_price3 : null,
          
          // Ensure real-time fields are present (backend sends them merged)
          last_px: item.last_px,
          px_change_rate: item.px_change_rate
        }
      }).sort((a, b) => {
        // Sort by (min(gain_to_100, gain_to_200) - px_change_rate) ascending
        const getSortVal = (item) => {
           let v1 = item.gain_to_100;
           let v2 = item.gain_to_200;
           
           // Ensure numbers and handle null/undefined
           v1 = (v1 !== null && v1 !== undefined && v1 !== '') ? Number(v1) : Infinity;
           v2 = (v2 !== null && v2 !== undefined && v2 !== '') ? Number(v2) : Infinity;
           
           if (isNaN(v1)) v1 = Infinity;
           if (isNaN(v2)) v2 = Infinity;

           const minVal = Math.min(v1, v2);
           
           if (minVal === Infinity) return Infinity;
           
           let pxChange = item.px_change_rate;
           pxChange = (pxChange !== null && pxChange !== undefined && pxChange !== '') ? Number(pxChange) : 0;
           if (isNaN(pxChange)) pxChange = 0;
           
           return minVal - pxChange;
        }
        
        const valA = getSortVal(a);
        const valB = getSortVal(b);
        
        if (valA === Infinity && valB === Infinity) return 0;
        if (valA === Infinity) return 1;
        if (valB === Infinity) return -1;

        return valA - valB;
      })
    }
  },
  watch: {
    date1: {
      handler() {
        this.fetchNextTradingDay()
      },
      immediate: true
    },
    date2() {
      // date2 change logic handled in other ways if needed
    },
    nextTradingDay(val) {
      if (val) {
        const idx = this.fields.findIndex(f => f.key === 'trigger_today')
        if (idx !== -1) {
          this.fields[idx].label = `今日触发(${val})`
        }
      }
    }
  },
  mounted(){
    this.setDefaultTradeDateByRule()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods:{
    onResize() {
      this.windowWidth = window.innerWidth
    },
    switchToNext() {
      this.prevDate = this.date1
      this.date1 = this.date2
      this.date2 = ''
      this.fetchList()
    },
    switchToPrev() {
      this.date2 = this.date1
      this.date1 = this.prevDate
      this.prevDate = ''
      this.fetchList()
    },
    fetchNextTradingDay() {
      if (!this.date1) return
      const start = moment(this.date1).add(1, 'days').format('YYYY-MM-DD')
      const end = moment(this.date1).add(15, 'days').format('YYYY-MM-DD')
      
      request_zzquant({
        url: '/v3/market/trade/days',
        params: { day_start: start, day_end: end }
      }).then(res => {
        if (res.data && res.data.code === 20000 && Array.isArray(res.data.data) && res.data.data.length > 0) {
          this.nextTradingDay = res.data.data[0]
        } else {
          this.nextTradingDay = ''
        }
      })
    },
    openSidebar(item) {
      this.sidebarSymbolCode = item.symbol_code
      this.sidebarSymbolName = item.symbol_name
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right-stock')
    },
    setDefaultTradeDateByRule() {
      const dayEnd = moment().utcOffset(8).add(1, 'days').format('YYYY-MM-DD')
      
      // Optimization: Check cache
      const cacheKey = `trade_date_${dayEnd}`
      const cachedData = sessionStorage.getItem(cacheKey)
      
      if (cachedData) {
        try {
          const parsed = JSON.parse(cachedData)
          if (parsed.date1) {
            this.date1 = parsed.date1
            this.date2 = parsed.date2 || ''
            this.fetchList()
            return
          }
        } catch (e) {
          // Fallback for plain text cache (old version)
          this.date1 = cachedData
          this.fetchList()
          return
        }
      }

      request_zzquant({
        url: '/v3/market/trade/days',
        params: { days: 2, day_end: dayEnd }
      }).then(res => {
        if (res.data && res.data.code === 20000 && Array.isArray(res.data.data) && res.data.data.length > 0) {
          this.date1 = res.data.data[0] //永远取前一个交易日
          this.date2 = res.data.data.length > 1 ? res.data.data[1] : '' //最近交易日
          
          // Cache both dates
          sessionStorage.setItem(cacheKey, JSON.stringify({
            date1: this.date1,
            date2: this.date2
          }))
        } else {
          this.date1 = dayEnd
        }
        this.fetchList()
      }).catch(() => {
        this.date1 = dayEnd
        this.fetchList()
      })
    },
    fetchList(){
      this.loading = true
      request_zzquant({
        url: '/market/movement/alerts',
        params: { date1: this.date1, type: 0, limit: 200, is_real: 1 }
      }).then(res=>{
        this.loading = false
        if (res.data.code === 20000) {
          this.items = res.data.data || []
        }
      }).catch(()=>{
        this.loading = false
      })
    },
    formatPrice(v){
      if (v===null || v===undefined) return '--'
      return Number(v).toFixed(2)
    },
    formatPct(v){
      if (v===null || v===undefined) return '--'
      return Number(v).toFixed(2) + '%'
    },
    getColorClass(val){
      if (val > 0) return 'text-danger'
      if (val < 0) return 'text-success'
      return ''
    },
    getTodayStyle(threshold, real) {
       if (threshold === null || real === null || real === undefined) return ''
       const diff = threshold - real
       if (threshold <= real) return 'bg-danger text-white'
       if (diff > 0 && diff < 10) return 'bg-warning text-dark'
       return ''
    },
    getFutureStyle(dist) {
       if (dist === null || dist === undefined) return ''
       if (dist < 0) return 'bg-danger text-white'
       if (dist < 10) return 'bg-warning text-dark'
       return ''
    },
    getMobileFutureClass(val) {
       if (val === null || val === undefined) return ''
       if (val < 0) return 'text-danger font-weight-bold'
       if (val < 10) return 'text-warning font-weight-bold'
       return ''
    },
    getMobileThresholdClass(threshold, real) {
       if (threshold === null || real === null || real === undefined) return ''
       const diff = threshold - real
       if (threshold < real) return 'text-danger font-weight-bold'
       if (diff > 0 && diff < 10) return 'text-warning font-weight-bold'
       return ''
    },
    getWeekDay(dateStr) {
      if (!dateStr) return ''
      const days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      return days[new Date(dateStr).getDay()]
    },
    async downloadScreenshot() {
      if (this.isGeneratingScreenshot) return
      this.isGeneratingScreenshot = true
      
      try {
        const element = this.$refs.tableContainer
        if (!element) return

        // Create watermark div
        const watermark = document.createElement('div')
        watermark.innerHTML = '自在量化<br>quant.zizizaizai.com'
        watermark.style.position = 'fixed'
        watermark.style.top = '50%'
        watermark.style.left = '50%'
        watermark.style.transform = 'translate(-50%, -50%) rotate(-30deg)'
        watermark.style.fontSize = '40px'
        watermark.style.color = 'rgba(150, 150, 150, 0.4)'
        watermark.style.zIndex = '9999'
        watermark.style.pointerEvents = 'none'
        watermark.style.textAlign = 'center'
        watermark.style.fontWeight = 'bold'
        element.appendChild(watermark)

        const html2canvas = (await import('html2canvas')).default
        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2, // Higher resolution
          backgroundColor: '#ffffff'
        })
        
        // Remove watermark
        element.removeChild(watermark)
        
        // Download
        const link = document.createElement('a')
        link.download = `异动提醒_${this.date1}.png`
        link.href = canvas.toDataURL('image/png')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
      } catch (error) {
        console.error('Screenshot failed:', error)
        this.$bvToast.toast('生成截图失败，请重试', {
          title: '错误',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isGeneratingScreenshot = false
      }
    }
  }
}
</script>

<style>
.sticky-header-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 1000;
  background-color: var(--bg-muted) !important;
  box-shadow: 0 1px 0 var(--border-color);
  border-top: none !important;
  color: var(--text-main) !important;
}
</style>
